import "core-js/modules/es.string.replace-all.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保单信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.policyInfoList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.policyInfo[item.key]).replaceAll("天", item.key == "waitTime" ? _vm.$t("天") : "天").replaceAll("年", item.key == "waitTime" ? _vm.$t("年") : "年") || "-") + " ")])]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };